import { apiCustomer } from '@/api'
import verifyUserInCart from '@/lib/verify-user-in-cart'
import { Address } from '@/types'

async function getUserAddresses() {
  await verifyUserInCart()

  return apiCustomer.get<Address[]>("/addresses")
    .then(response => response.data)
    .catch(() => {
      throw new Error("something went wrong retrieving user addresses")
    })
}

export default getUserAddresses
